<div>
  <div class="m-3">
    <button type="button" class="close p-3" aria-label="Close" (click)="closeSelected()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3 class="modal-title">Where did you go?</h3>
    <p>Let us know where you went so we can keep your health record and care up to date.</p>
  </div>
  <hr m-0 />
  <div class="modal-body mx-3">
    <div class="mb-3">
      <p class="mb-2">Provider or Facility Name</p>
      <input
        type="text"
        class="form-control form-input"
        required
        [(ngModel)]="providerOrFacilityName"
        placeholder="e.g. Andrew Diamond, UCSF"
      />
    </div>
    <div class="mb-2">
      <p class="mb-2">City</p>
      <input
        type="text"
        class="form-control form-input"
        required
        [(ngModel)]="cityName"
        placeholder="e.g. San Francisco"
      />
    </div>
  </div>

  <div class="modal-footer">
    <div class="row">
      <div> <button (click)="complete()" class="btn btn-lg btn-block mb-3 btn-alternate"> I Don't Know </button> </div>
      <div class="mx-3">
        <button
          (click)="completeWithWentElsewhereInfo()"
          class="btn btn-lg btn-primary btn-block mb-3"
          [disabled]="!cityName || !providerOrFacilityName"
        >
          Send
        </button>
      </div>
    </div>
  </div>
</div>
